import { render, staticRenderFns } from "./FilesEditor.vue?vue&type=template&id=487cb505&"
import script from "./FilesEditor.vue?vue&type=script&lang=js&"
export * from "./FilesEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports